import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Injectable({
  providedIn: 'root'
})
export class HelpdeskGuard implements CanActivateChild {
  
  constructor(
    private router: Router,
    private cryptoJsService: CryptoJsService
  ) { }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encDataD);
    const tokenInfo = loginDetails.get('tokenInfo') ? loginDetails.get('tokenInfo') : null;
    const userRole = tokenInfo['role'] ? tokenInfo['role'] : null;
    const isHelpdeskLogin = loginDetails.get('isHelpdesk') ? loginDetails.get('isHelpdesk') : null;

    console.log('Hi')
    if (isHelpdeskLogin == '1' || userRole === "DD Associate") {
      return true;
    } else {
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }
  }
  
}